/**
 * @fileoverview Hook para validar sesión activa. Si no hay
 * session_token, redirige a inicio.
 */

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useParticipacion } from "../context/ParticipacionContext";

/**
 * Redirige a `/` si no hay session_token vivo. Llamar al inicio
 * de cualquier página que requiera sesión.
 */
export function useRequireSession() {
    const navigate = useNavigate();
    const { state } = useParticipacion();

    useEffect(() => {
        if (!state.session_token) {
            navigate("/", { replace: true });
        }
    }, [state.session_token, navigate]);

    return state;
}
